var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from 'react';
import { Button } from '../button/Button';
import { GroupButton } from '../button/GroupButton';
var PaginationControls = /** @class */ (function (_super) {
    __extends(PaginationControls, _super);
    function PaginationControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getDottesButton = function (key) {
            return (React.createElement(Button, { key: key, color: 'primary', outline: true, size: 'sm', disabled: true }, "..."));
        };
        return _this;
    }
    PaginationControls.prototype.render = function () {
        var _a = this.props, itemsTotal = _a.itemsTotal, itemsPerPage = _a.itemsPerPage, currentPage = _a.currentPage, onChangePage = _a.onChangePage, buttonSize = _a.buttonSize;
        var buttonsSize = buttonSize ? buttonSize : 'sm';
        if (itemsTotal <= itemsPerPage) {
            return null;
        }
        else {
            var countPages_1 = Math.floor(itemsTotal / itemsPerPage) + Math.sign(itemsTotal % itemsPerPage);
            var buttons = [];
            var COUNT_CONTROLS_ON_SIDE = 1;
            var startPage = Math.max(1, currentPage -
                COUNT_CONTROLS_ON_SIDE -
                Math.max(COUNT_CONTROLS_ON_SIDE - (countPages_1 - currentPage), 0));
            var lastPage = Math.min(startPage + COUNT_CONTROLS_ON_SIDE * 2, countPages_1);
            buttons.push(React.createElement(Button, { key: 'start', color: 'primary', outline: true, size: buttonsSize, onClick: function () {
                    onChangePage(1);
                }, disabled: currentPage === 1 }, "\u0432 \u043D\u0430\u0447\u0430\u043B\u043E"));
            if (startPage !== 1) {
                buttons.push(this.getDottesButton('dottes-before'));
            }
            var _loop_1 = function (pageIndex) {
                buttons.push(React.createElement(Button, { key: pageIndex, color: 'primary', outline: currentPage !== pageIndex, size: buttonsSize, onClick: function () {
                        onChangePage(pageIndex);
                    } }, pageIndex));
            };
            for (var pageIndex = startPage; pageIndex <= lastPage; pageIndex++) {
                _loop_1(pageIndex);
            }
            if (lastPage !== countPages_1) {
                buttons.push(this.getDottesButton('dottes-after'));
            }
            buttons.push(React.createElement(Button, { key: 'finish', color: 'primary', outline: true, size: buttonsSize, onClick: function () {
                    onChangePage(countPages_1);
                }, disabled: currentPage === countPages_1 }, "\u0432 \u043A\u043E\u043D\u0435\u0446"));
            return React.createElement(GroupButton, { className: 'my-x4 pagination-btn' }, buttons);
        }
    };
    return PaginationControls;
}(PureComponent));
export default PaginationControls;
//# sourceMappingURL=PaginationControls.js.map